import { type Components, type Theme } from "@mui/material/styles";

export const muiScrollbarOverrides: Components<Theme> = {
  MuiCssBaseline: {
    styleOverrides: (theme) => ({
      "*::-webkit-scrollbar": {
        width: "8px",
        height: "8px",
      },
      "*::-webkit-scrollbar-track": {
        backgroundColor: theme.palette.background?.muted,
        borderRadius: theme.borderRadius?.small,
      },
      "*::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.border?.strong,
        borderRadius: theme.borderRadius?.small,
        border: `2px solid ${theme.palette.background?.base}`,
        transition: "background-color 0.2s ease",
      },
      "*::-webkit-scrollbar-thumb:hover": {
        backgroundColor: theme.palette.base?.inactive,
      },
      "*::-webkit-scrollbar-corner": {
        backgroundColor: theme.palette.background?.muted,
      },
      // Hide scrollbar arrow buttons completely (up/down arrows)
      "*::-webkit-scrollbar-button": {
        display: "none",
        height: "0px",
        width: "0px",
      },
      "*::-webkit-scrollbar-button:start:decrement": {
        display: "none",
      },
      "*::-webkit-scrollbar-button:end:increment": {
        display: "none",
      },

      "*": {
        scrollbarWidth: "thin",
        scrollbarColor: `${theme.palette.border?.strong} ${theme.palette.background?.muted}`,
      },
    }),
  },
};
